import {Directive, ElementRef, AfterViewInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import {Moment} from '../../helpers/core/moment/moment';

declare var $: any;

@Directive({
    selector: '[appDatePicker]'
})
export class DatePickerDirective implements AfterViewInit, OnDestroy {
    @Input() public startDate: string;
    @Input() public endDate: string;
    @Input() public maxDate: string;
    @Output() public changed = new EventEmitter<string>();
    private element: any;
    private dateRangePicker: any;

    constructor(el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this.dateRangePicker = this.element.daterangepicker({
            singleDatePicker: true,
            maxDate: this.maxDate ? this.maxDate : Moment.CurrentTime('DD/MM/YYYY'),
            locale: {
                format: 'DD/MM/YYYY'
            }
        }, (date) => {
            this.changed.emit(date.format('DD/MM/YYYY'));
        });
        if (this.startDate) {
            this.element.data('daterangepicker').setStartDate(this.startDate);
        }
        if (this.endDate) {
            this.element.data('daterangepicker').setEndDate(this.endDate);
        }
    }

    ngOnDestroy(): void {
        if (this.dateRangePicker) {
            this.dateRangePicker.each((i, item) => {
                $(item).data('daterangepicker').remove();
            });
        }
    }
}
